
export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 600,
    nextArrow,
    prevArrow
};

export const prevArrow = `
    <button class="slideroo__prev button solid">
        <svg class="icon icon--prev" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" style="transform:rotate(90deg)">
            <path d="M31.946 17.778 22.5 27.225l-9.446-9.447" fill="none" stroke="currentColor" stroke-width="6"/>
        </svg>
    </button>`;
export const nextArrow = `
    <button class="slideroo__next button solid">
        <svg class="icon icon--next" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" style="transform:rotate(-90deg)">
            <path d="M31.946 17.778 22.5 27.225l-9.446-9.447" fill="none" stroke="currentColor" stroke-width="6"/>
        </svg>
    </button>`;

